import WorkingArea from '@/models/WorkingArea';

const LOAD_WORK_EXPERIENCE_RESOURCES = 'load_work_experience_resources';

const LOAD_WORK_EXPERIENCE_RESOURCES_REQUEST = 'load_work_experience_resources_request';
const LOAD_WORK_EXPERIENCE_RESOURCES_SUCCESS = 'load_work_experience_resources_success';
const LOAD_WORK_EXPERIENCE_RESOURCES_ERROR = 'load_work_experience_resources_error';

export { LOAD_WORK_EXPERIENCE_RESOURCES };

export default {
    state: {
        loading: false,
        working_areas: [],
    },
    mutations: {
        [LOAD_WORK_EXPERIENCE_RESOURCES_REQUEST] (state) {
            state.loading = true;
        },
        [LOAD_WORK_EXPERIENCE_RESOURCES_SUCCESS](state, { working_areas }) {
            state.loading = false;
            state.working_areas = working_areas;
        },
        [LOAD_WORK_EXPERIENCE_RESOURCES_ERROR] (state, errors) {
            state.loading = false;
        }
    },
    actions: {
        [LOAD_WORK_EXPERIENCE_RESOURCES] ({ commit, state }) {
            commit(LOAD_WORK_EXPERIENCE_RESOURCES_REQUEST);

            let working_areas_promise = WorkingArea.collection();

            Promise.all([working_areas_promise])
                .then(values => {
                    commit(LOAD_WORK_EXPERIENCE_RESOURCES_SUCCESS, {
                        working_areas: values[0].items,
                    });
                }).catch(({ status, errors }) => {
                    commit(LOAD_WORK_EXPERIENCE_RESOURCES_ERROR, errors);
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/work-experience-resources.js